import { Provider } from '@angular/core'
import { environment } from '../../environments/environment'
import { gamePlayConfigToken } from 'shared-components'
import { GamePlayConfig } from 'shared-services'

const gamePlayConfig: GamePlayConfig = {
  apiBaseUrl: environment.gamePlayApiBaseUrl,
  getGamePlayPollTimeoutInMilliseconds:
    environment.getGamePlayPollTimeoutInMilliseconds,
}

export const playGamePlayConfigProvider: Provider = {
  provide: gamePlayConfigToken,
  useValue: gamePlayConfig,
}
